<template>
	<div>
		<v-layout row wrap justify-end mb-3>
			<v-flex md2>
				<button-create
					text="Agregar"
					btn-function
					@function-click="openModal">
				</button-create>
			</v-flex>
		</v-layout>
		<table-run
			:columns="columns"
			:rows="rows"
			:include-delete="false"
			:include-export-to-excel="false"
			:include-options="true"
			:include-switch="true"
			:include-settings="true"
			:include-delete-single="true"
			:selectable="false"
			:switch-value="'flagActive'"
			v-on:on-sortable-event="columnSortableEvent"
			v-on:on-search-event="searchByColumn"
			v-on:on-change-state="changeState"
			v-on:on-delete-event="deleteRow"
			v-on:go-to-edit-page="openModal"
			class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{ props.row.name }}</td>
				<td>{{ props.row.code }}</td>
				<td>{{ props.row.color }}</td>
				<td>
					<img
						v-if="props.row.urlImage"
						:src="props.row.urlImage"
						:alt="props.row.name"
						class="table-img"
						height="38"
						width="40">
				</td>
			</template>    
		</table-run>
		<v-layout row wrap justify-end mt-3>
			<v-pagination
				v-bind:length="totalPages"
				v-model="params.page"
				:total-visible="pagesVisible"
				v-on:input="loadData(params.page)">
			</v-pagination>
		</v-layout>
		<v-layout row justify-center>
			<v-dialog v-model="form" persistent width="50%">
				<v-card>
					<v-card-title>
						<span class="headline">Agregar Categoría</span>
					</v-card-title>
					<v-card-text>
						<v-layout wrap text-xs-left>
							<v-flex xs12 sm6 pr-1>
								<label class="label-form">Nombre</label>
								<v-text-field
									type="text"
									class="input-border-inset"
									v-model="model.name">
								</v-text-field>
								<span class="caption red--text"
									v-if="$v.model.name && $v.model.name.$invalid">
									El nombre es requerido
								</span>
							</v-flex>
							<v-flex xs12 sm6 px-1>
								<label class="label-form">Código</label>
								<v-text-field
									type="text"
									class="input-border-inset"
									v-model="model.code">
								</v-text-field>
								<span class="caption red--text"
									v-if="$v.model.code && $v.model.code.$invalid">
									El código es requerido
								</span>
							</v-flex>
							<v-flex xs12 sm6 px-1>
								<label class="label-form">Color</label>
								<v-text-field
									type="color"
									class="input-border-inset"
									v-model="model.color">
								</v-text-field>
							</v-flex>
							<v-flex xs12 sm5 px-1 mt-3>
								<v-switch
								label="Mostrar en POS"
								hiden-details
								v-model="model.flagMain"
								class="input-switch"
								>
									
								</v-switch>
							</v-flex>
							<v-flex xs12 pl-1 mt-3>
								<label class="label-form">Imagen</label>
								<file-upload-container
									v-bind:label-for="`image-${rows.length + 1}`"
									v-on:upload="onUploadImage"
									v-bind:image-url="model.urlImage"
									v-bind:min-resolution="10"
									v-bind:max-resolution="3000"
								/>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-card-actions class="mt-4">
						<v-layout row wrap justify-center>
							<v-flex xs3 pr-2>
								<v-btn
									type="button"
									primary
									class="btn-action"
									@click.native="closeModal">
									Cancelar
								</v-btn>
							</v-flex>
							<v-flex xs3 pl-2>
								<v-btn
									class="btn-action btn-success white--text"
									:disabled="$v.$invalid"
									@click.native="createCategory">
									Guardar
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>
	</div>
</template>

<script>
	import { required } from 'vuelidate/lib/validators';
	import TableRun from 'table-run';
	import helper from '@/shared/helper';
	import mixin from '@/shared/mixins';
	import ButtonCreate from '@/components/shared/ButtonCreate';
	import FileUploadContainer from '@/components/shared/FileUpload/FileUploadContainer';

	const helperData = helper.data();

	function created() {
		this.loadData();
	}

	async function changeState({ id }) {
		const flagActive = this.rows.find(row => row.id === id).flagActive;
		await this.$http.patch(`${process.env.PRODUCTS_URL}/p/categories/${id}/flag-active`, { flagActive });
		this.showNotification('El estado de la categoría se actualizó correctamente.', 'success');
		this.loadData();
	}

	function closeModal() {
		this.form = false;
		this.model = {
			code: '',
			color: '',
			name: '',
			flagActive: true,
			flagMain: true,
			urlImage: helperData.preimageUrl,
		};
	}

	function columnSortableEvent({ id }) {
		const newColumn = this.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		this.columns = this.columns.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
			return newColumnSingle;
		});
		this.params.sortField = newColumn[0].code;
		this.params.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
		this.loadData();
	}

	async function createCategory() {
		if (this.model.urlImage === helperData.preimageUrl) {
			delete this.model.urlImage;
		}
		const method = this.model.id ? 'patch' : 'post';
		const url = this.model.id ? `categories/${this.model.id}` : 'categories';
		const message = this.model.id ? 'actualizó' : 'creó';
		const updateModel = {
			name: this.model.name,
			code: this.model.code,
			color: this.model.color,
			flagActive: this.model.flagActive,
			flagMain: this.model.flagMain,
		};
		if (this.model.urlImage) {
			updateModel.urlImage = this.model.urlImage;
		}
		const saveData = this.model.id ? updateModel : this.model;
		await this.$http[method](`${process.env.PRODUCTS_URL}/p/${url}`, saveData);
		this.showNotification(`La categoría se ${message} correctamente.`, 'success');
		this.loadData();
		this.closeModal();
	}

	async function deleteRow({ id }) {
		try {
			await this.$http.delete(`${process.env.PRODUCTS_URL}/p/categories/${id}`);
			this.showNotification('La categoría se eliminó correctamente.', 'success');
			this.loadData();
		} catch (err) {
			const message = err.data.message;
			if (err.data.statusCode === 400) {
				if (message === 'CANNOT_BE_DELETED') {
					this.showNotification('La categoría no puede ser eliminada porque tiene productos asociados.', 'error');
				}
			}
		}
	}

	async function loadData(page = 1) {
		this.params.page = page;
		const { data: categories, headers } = await this.$http.get(`${process.env.PRODUCTS_URL}/p/categories`, { params: this.params });
		this.totalPages = Number(headers.get('x-last-page'));
		this.rows = categories;
	}

	function onUploadImage(url) {
		this.model.urlImage = url;
	}

	async function openModal(row) {
		if (row && row.id) {
			const { data: category } = await this.$http.get(`${process.env.PRODUCTS_URL}/p/categories/${row.id}`);
			category.color = category.color ? category.color : this.randomColor();
			this.model = category;
			this.model.urlImage = category.urlImage || helperData.preimageUrl;
		} else {
			this.model.color = this.randomColor();
		}
		this.form = true;
	}

	function pagesVisible() {
		return this.totalPages < 5 ? this.totalPages : 5;
	}

	function randomColor() {
		const color = Math.floor(Math.random() * 16777215).toString(16);
		return `#${color}`;
	}

	function searchByColumn(search) {
		this.params.search = search;
		this.loadData();
	}

	function validations() {
		return {
			model: {
				code: {
					required,
				},
				name: {
					required,
				},
			},
		};
	}

	function data() {
		return {
			columns: [
				{ id: 1, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Código', code: 'code', isSortable: { down: false, up: false } },
				{ id: 3, name: 'Color', code: 'color', isSortable: { down: false, up: false } },
				{ id: 4, name: 'Imagen', code: 'urlImage', isSortable: { down: false, up: false } },
			],
			form: false,
			model: {
				code: '',
				color: '',
				urlImage: helperData.preimageUrl,
				flagActive: true,
				name: '',
				flagMain: true,
			},
			params: {
				limit: 10,
				page: 1,
			},
			rows: [],
			totalPages: 0,
		};
	}

	export default {
		name: 'categories-list',
		components: {
			ButtonCreate,
			FileUploadContainer,
			TableRun,
		},
		computed: {
			pagesVisible,
		},
		created,
		data,
		methods: {
			changeState,
			closeModal,
			columnSortableEvent,
			createCategory,
			deleteRow,
			loadData,
			onUploadImage,
			openModal,
			randomColor,
			searchByColumn,
		},
		mixins: mixin,
		validations,
	};
</script>

<style lang="scss" scoped>
	.table-img {
		margin: 6px auto 0px;
	}
</style>


// WEBPACK FOOTER //
// List.vue?d54b82ba